import { render, staticRenderFns } from "./CartOrderRecord.vue?vue&type=template&id=5d222de7&scoped=true&"
import script from "./CartOrderRecord.vue?vue&type=script&lang=js&"
export * from "./CartOrderRecord.vue?vue&type=script&lang=js&"
import style0 from "./CartOrderRecord.vue?vue&type=style&index=0&id=5d222de7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d222de7",
  null
  
)

export default component.exports